var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3767",
    "data-name": "Rectangle 3767",
    width: 24,
    height: 24,
    transform: "translate(65 544)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4733",
    "data-name": "Mask Group 4733",
    transform: "translate(-65 -544)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7603",
    "data-name": "Group 7603",
    transform: "translate(68.292 546.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7602",
    "data-name": "Group 7602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8207",
    "data-name": "Path 8207",
    d: "M10.567,0a.379.379,0,0,0,.064.029,1.426,1.426,0,0,1,1.145,1.234c.048.293.1.586.146.879a1.067,1.067,0,0,0,1.432.847c.3-.1.589-.222.884-.33a1.416,1.416,0,0,1,1.793.642q.736,1.262,1.461,2.53a1.411,1.411,0,0,1-.325,1.861c-.24.2-.488.4-.728.6a1.062,1.062,0,0,0,0,1.674c.244.208.5.406.741.615a1.4,1.4,0,0,1,.325,1.819q-.739,1.3-1.5,2.592a1.409,1.409,0,0,1-1.726.624c-.3-.105-.6-.227-.9-.335a1.066,1.066,0,0,0-1.465.857c-.057.333-.106.669-.175,1A1.394,1.394,0,0,1,10.4,18.258q-1.543.014-3.086,0A1.42,1.42,0,0,1,5.933,17c-.048-.293-.1-.586-.146-.879a1.066,1.066,0,0,0-1.429-.852c-.3.1-.589.221-.884.329a1.416,1.416,0,0,1-1.794-.638Q.939,13.694.21,12.418a1.408,1.408,0,0,1,.329-1.846c.24-.2.488-.4.728-.6a1.063,1.063,0,0,0,0-1.675c-.244-.208-.5-.406-.741-.615A1.4,1.4,0,0,1,.2,5.862Q.938,4.56,1.7,3.27a1.413,1.413,0,0,1,1.742-.624c.3.105.588.224.884.33a1.067,1.067,0,0,0,1.468-.852q.074-.43.144-.861A1.426,1.426,0,0,1,7.078.029.377.377,0,0,0,7.142,0h3.425M1.432,6.577l.729.6a2.5,2.5,0,0,1-.005,3.91l-.711.586a.165.165,0,0,0,.008.043q.711,1.235,1.421,2.47c.047.081.092.085.172.053.276-.109.554-.212.834-.312a2.491,2.491,0,0,1,3.3,1.889c.062.336.117.674.175,1.009h3c.048-.288.1-.568.141-.85a2.489,2.489,0,0,1,3.039-2.13,8.921,8.921,0,0,1,1.107.388c.107.041.155.022.209-.076.145-.266.3-.525.452-.788l.973-1.687-.707-.584a2.493,2.493,0,0,1,0-3.942c.233-.191.466-.384.7-.581-.487-.843-.969-1.674-1.447-2.509-.051-.088-.1-.071-.175-.043-.305.116-.609.237-.919.337a2.489,2.489,0,0,1-3.207-1.908c-.062-.338-.117-.677-.176-1.021h-3c-.047.282-.1.561-.141.842A2.5,2.5,0,0,1,3.79,4.3c-.25-.093-.5-.191-.752-.275a.168.168,0,0,0-.152.043C2.4,4.9,1.92,5.731,1.432,6.577",
    transform: "translate(0)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8208",
    "data-name": "Path 8208",
    d: "M115.282,124.872a3.518,3.518,0,1,1,3.635-3.4,3.539,3.539,0,0,1-3.635,3.4m.111-5.614a2.095,2.095,0,1,0,2.1,2.1,2.11,2.11,0,0,0-2.1-2.1",
    transform: "translate(-106.541 -112.223)",
    fill: "#9e9e9e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.917f3aef13dd611a7c41b14f05a6bd38.svg";
export { ForwardRef as ReactComponent };